import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { addVlmFile, startVlmById } from '../../api/vlm.api'
import { Grid, Button, Tooltip, Typography, CircularProgress } from '@mui/material'
import * as actions from '../../reducers/materialLoad';
import * as actions2 from '../../reducers/form';
import { API_BO } from '../../conf'


const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  input: {
    display: 'none',
  },
  edt: {
    padding: '1px',
  },
  main: {
    margin: theme.spacing(1)
  },
  formControl: {
    margin: theme.spacing(3),
    minWidth: 240,
    marginTop: 5,
    marginBottom: 3,
    width: '50%'
  },
}));
export default function VlmAdd(props) {
  const classes = useStyles();
  const dispatch = useDispatch()
  const [idVlm, setIdVlm] = useState(null)
  const [fileName, setFileName] = useState('');
  const [fileNameShort, setFileNameShort] = useState('');
  const [loading, setLoading] = useState(false)
  const handleLoadFile = (e) => {
    e.preventDefault();
    if (typeof e.target.files[0] === 'undefined' || e.target.files[0].length === 0) return
    setLoading(true)
    let shortName = e.target.files[0].name
    if (shortName.length > 38) {
      shortName = e.target.files[0].name.slice(0, 17) + '...' + e.target.files[0].name.slice(-18)
    }
    dispatch(actions.loadFileAPI({ file: e.target.files[0], path: addVlmFile.path }))
      .then(res => {
        if (res.success) {
          setIdVlm(res.id);
          setFileName(e.target.files[0].name);
          setFileNameShort(shortName);
        }
        setLoading(false)
      })
      .catch()
  }
  const handleStart = () => {
    dispatch(actions2.formSubmitAPI({
      props: {},
      url: startVlmById.path({ id: idVlm }),
      method: startVlmById.type,
      endFunc: (res)=>{
        props.history.push(`${API_BO}/vlm/${res.get.id}`)
      }
    }, 'formName'))
  }
  return <div className='App-paper'>
    <Typography>Создать задачу на распознавание</Typography>
    <div className={classes.formControl}>
      <input
        className={classes.input}
        id="contained-button-file"
        type="file"
        accept="image/png"
        onChange={handleLoadFile}
      />
      <label htmlFor="contained-button-file">
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item >
            <Button variant='contained' component="span" size="small">Файл</Button>
          </Grid>
          <Grid item >
            <Tooltip title={fileName}><Typography>{fileNameShort}</Typography></Tooltip>
          </Grid>
          <Grid item >
            {loading && <CircularProgress size={20} />}
          </Grid>
        </Grid>
      </label>
      <Button color="primary" onClick={() => props.history.goBack()}>Назад </Button>
      <Button variant='contained' onClick={handleStart} disabled={!idVlm}>Начать распознавание</Button>
    </div>
  </div>
}